import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useVendor } from 'features/vendor';

/**
 * App shell for authenticated pages: fixed sidebar on desktop, slide-over
 * drawer on mobile, sticky topbar, and a centered content column.
 */
export function DashboardLayout() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { profile } = useVendor();

  // Lock body scroll + close on Escape while the mobile drawer is open
  // (mirrors the Modal behaviour for consistency).
  useEffect(() => {
    if (!isSidebarOpen) return undefined;
    const handleKey = (event) => {
      if (event.key === 'Escape') setSidebarOpen(false);
    };
    document.addEventListener('keydown', handleKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [isSidebarOpen]);

  return (
    <div className="min-h-full">
      {/* Desktop sidebar */}
      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r border-surface-200 bg-white lg:block">
        <Sidebar profile={profile} />
      </aside>

      {/* Mobile drawer */}
      {isSidebarOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div
            className="absolute inset-0 bg-slate-900/40"
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
          />
          <aside className="absolute inset-y-0 left-0 w-64 bg-white shadow-xl">
            <Sidebar profile={profile} onNavigate={() => setSidebarOpen(false)} />
          </aside>
        </div>
      )}

      <div className="lg:pl-64">
        <Topbar onOpenSidebar={() => setSidebarOpen(true)} profile={profile} />
        <main className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
